import { api } from '@/lib/api';

export type TrueCareWelcomeAnalytics = {
  generatedAt: string;
  hospitalId: string;
  range: { from: string | null; to: string | null };
  totalRegistrations: number;
  whatsappSent: number;
  whatsappDelivered: number;
  whatsappRead: number;
  whatsappFailed: number;
  deliveryRatePct: number;
  readRatePct: number;
  appDownloadClicks: number;
  appInstallsFromRegistration: number;
  installRatePct: number;
  recentNotifications: Array<{
    id: string;
    patientId: string;
    patientName: string;
    uhid: string | null;
    mobile: string;
    status: string;
    sentAt: string | null;
    deliveredAt: string | null;
    readAt: string | null;
    createdAt: string;
  }>;
};

export const truecareWelcomeAnalyticsApi = {
  getDashboard: (params?: { from?: string; to?: string }) =>
    api
      .get<{ data: TrueCareWelcomeAnalytics }>('/api/loyalty/truecare-welcome-analytics', {
        params,
      })
      .then((r) => r.data.data),
};
